(ns manage.ad-variant.creation.manual-upload-ocp.view
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Collapse$default" :as Collapse]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/TextField$default" :as TextField]
            ["react-hook-form" :as rhf]
            ["src/svg/files_folders/bin.svg$default" :as Bin]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.form :as form]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.util :refer [spread-props]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.form-field :refer [form-field hint]]
            [common.widgets.upload :as wu]
            [lemonpi.ads-schema.interface :as ads-schema]
            [manage.ad-variant.creation.manual-upload-ocp.carousel :refer [carousel-cards-component]]
            [manage.ad-variant.creation.manual-upload-ocp.hooks :as hooks]
            [manage.ad-variant.creation.video-format-picker :as vfp]
            [manage.ad-variant.details-ocp.preview :refer [variant-preview]]
            [manage.ad-variant.schedule-modal :as schedule-modal]
            [manage.adset.hooks :as adset.h]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(defui video-component [{:keys [name]}]
  (let [[_ video-index] (str/split name "-")]
    ($ form/asset-upload
       {:name (str name ".url")
        :label (if video-index (str "Video " video-index) "Video")
        :path [::manual-ad-video]
        :extensions ".mp4, .mov"
        :filetype "video"
        :hint-text "Supported formats: .mp4, .mov"})))

(defui vast-video-component [{:keys [name]}]
  (let [[video-count set-video-count] (uix/use-state 1)]
    ($ :<>
       (for [idx (range video-count)
             :let [[base-name _] (str/split name "-")]]
         ($ video-component
            {:key idx
             :name (str base-name "-" (inc idx))}))
       ($ Button
          {:onClick #(set-video-count inc)
           :disabled (>= video-count 8)
           :startIcon ($ Plus)
           :sx #js {:alignSelf "flex-start"}}
          "Add additional video"))))

(defui image-component [{:keys [name]}]
  ($ form/asset-upload
     {:name (str name ".url")
      :label "Image"
      :path [::manual-ad-image]
      :extensions ".jpg, .jpeg, .png, .gif"
      :filetype "image"
      :hint-text "Supported formats: .jpg, .jpeg, .png, .gif"}))

(defn- text-field-component [label]
  (fn [^js props]
    ($ form-field {:label label}
       ($ form/form-text-field {:name (.-name props)}))))

(def ^:private primary-text-component  (text-field-component "Primary text"))
(def ^:private ad-name-component       (text-field-component "Ad name"))
(def ^:private ad-text-component       (text-field-component "Ad text"))
(def ^:private click-through-component (text-field-component "Click through"))
(def ^:private headline-component      (text-field-component "Headline"))
(def ^:private description-component   (text-field-component "Description"))
(def ^:private cta-caption-component   (text-field-component "CTA caption"))

(defui cta-component [{:keys [name format]}]
  (let [{:keys [control]} (form/use-form-context)]
    ($ form-field
       {:label "CTA"}
       ($ form/autocomplete-field
          {:control control
           :name name
           :field-props {:options (hooks/use-cta-options format)}}))))

(defui template-upload-success []
  ($ Stack {:direction "row" :alignItems "center" :gap 1 :sx #js {:mb 1}}
     ($ Icon {:color "success" :sx #js {:fontSize 18}} "check_circle")
     ($ :span "Template uploaded")))

(defui template-upload [{field-name :name
                         :keys [content-id]
                         {:keys [onChange value]} :field
                         {{:keys [message]} :error} :fieldState}]
  (let [{:keys [upload-template overlay-state]} (hooks/use-template-upload)
        {:keys [setValue setError]} (form/use-form-context)
        on-upload
        (uix/use-callback
         (fn [on-change file]
           (when file
             (if (str/blank? content-id)
               (setError "content-id" #js {:type "manual" :message "Content ID is required before uploading a template"})
               (upload-template
                {:file file :content-id content-id}
                #js {:onSuccess
                     (fn [^js response]
                       (let [{:keys [base-url placeholders]
                              {:keys [width height]} :dimensions} (->clj response)
                             click-phs (filter (fn [[_ {:keys [type]}]] (= "click" type))
                                               placeholders)]
                         (on-change base-url)
                         (when (and width height)
                           (setValue (str field-name ".width") width)
                           (setValue (str field-name ".height") height))
                         (when (seq click-phs)
                           (setValue "components.content"
                                     (->js (mapv (fn [[k {:keys [preview_content]}]]
                                                   {:key (name k)
                                                    :value (or preview_content "")})
                                                 click-phs))))))}))))
         [content-id field-name setValue setError upload-template])]
    ($ form-field {:label "Template" :err-msg message}
       (when value ($ template-upload-success))
       ($ wu/upload
          {:extensions ".zip"
           :enableEdit false
           :enablePreview false
           :overlay-state overlay-state
           :onChange #(on-upload onChange %)
           :relative-box true})
       ($ hint "Supported format: .zip"))))

(defui display-template-dimensions [{:keys [name]}]
  ($ Stack {:direction "row" :gap 1}
     ($ form-field {:label "Width"}
        ($ form/form-text-field
           {:name (str name ".width")
            :field-props {:required true :type "number" :placeholder "e.g. 300"}}))
     ($ form-field {:label "Height"}
        ($ form/form-text-field
           {:name (str name ".height")
            :field-props {:required true :type "number" :placeholder "e.g. 250"}}))))

(defui display-template-component [{:keys [name ad-prefix content-id]}]
  ($ :<>
     ($ rhf/Controller
        {:name (str name ".base-url")
         :render (fn [^js props]
                   ($ template-upload (assoc (->clj props)
                                             :name name
                                             :ad-prefix ad-prefix
                                             :content-id content-id)))})
     ($ display-template-dimensions {:name name})))

(defui display-content-component [{:keys [name]}]
  (let [{:keys [fields append remove]} (form/use-field-array #js {:name name})]
    ($ form-field {:label "Click tags"}
       ($ Stack {:gap 1}
          (for [[idx field] (mc/seq-indexed fields)]
            ($ Stack
               {:key (.-id field)
                :direction "row"
                :gap 1}
               ($ form/form-text-field
                  {:name (str name "[" idx "].key")
                   :field-props {:sx #js {:flex "0 0 140px"}}})
               ($ form/form-text-field
                  {:name (str name "[" idx "].value")
                   :field-props {:placeholder "Click URL"
                                 :sx #js {:flex 1}}})
               ($ IconButton
                  {:onClick #(remove idx)
                   :sx #js {:alignSelf "flex-start"}}
                  ($ SvgIcon ($ Bin)))))
          ($ Button
             {:onClick #(append #js {:key (str "clickTag" (inc (count fields))) :value ""})
              :startIcon ($ Plus)
              :sx #js {:alignSelf "flex-start"}}
             "Add click tag")))))

(def ^:private component-key->input-component
  {:video        video-component
   :video-1      vast-video-component
   :image        image-component
   :primary-text primary-text-component
   :ad-text      ad-text-component
   :ad-name      ad-name-component
   :click-through click-through-component
   :headline     headline-component
   :description  description-component
   :cta-caption  cta-caption-component
   :cta          cta-component
   :template     display-template-component
   :content      display-content-component
   :cards        carousel-cards-component})

(defui targeting-value [{:keys [name on-delete]}]
  (let [{:keys [control]} (form/use-form-context)]
    ($ Stack
       {:direction "row"
        :gap 1}
       ($ form/form-text-field
          {:name (str name ".name")
           :control control
           :field-props {:placeholder "Key"
                         :sx #js {:flex 1}}})
       ($ rhf/Controller
          {:name (str name ".value")
           :control control
           :render (fn [^js props]
                     (let [{{:keys [error]} :fieldState
                            {:keys [onChange] :as field} :field} (->clj props)]
                       ($ Autocomplete
                          (spread-props
                           field
                           {:multiple true
                            :freeSolo true
                            :options #js []
                            :filterOptions (fn [^js _options ^js state]
                                             (let [input (.toLowerCase (.-inputValue state))]
                                               (if (seq input)
                                                 #js [#js {:label (str "Add \"" input "\"")
                                                           :value input}]
                                                 #js [])))
                            :getOptionLabel (fn [option]
                                              (if (string? option)
                                                option
                                                (.-label option)))
                            :onChange (fn [_ value]
                                        (let [v (->> value
                                                     ->clj
                                                     (map (fn [v]
                                                            (if (map? v)
                                                              (:value v)
                                                              v)))
                                                     ->js)]
                                          (onChange v)))
                            :renderInput (fn [^js props]
                                           ($ TextField
                                              (spread-props
                                               props
                                               #js {:helperText (:message error)
                                                    :error (boolean error)
                                                    :placeholder "Values"})))
                            :sx #js {:flex 1}}))))})
       ($ IconButton
          {:onClick on-delete
           :sx #js {:alignSelf "flex-start"}}
          ($ SvgIcon
             ($ Bin))))))

(defui video-format-field
  []
  (let [{:keys [setValue]} (form/use-form-context)
        processing (rhf/useWatch #js {:name "processing"})
        video-format (if (= processing "transcode") "stv" "olv")]
    ($ form-field {:label "Format"}
       ($ vfp/video-format-selector
          {:video-format video-format
           :set-video-format
           (fn [chosen]
             (if (= chosen "stv")
               (do (setValue "format" "vast-aws-prime")
                   (setValue "processing" "transcode")
                   (setValue "placement" "amazon-stv")
                   (doseq [k ads-schema/vast-video-keys]
                     (setValue (str "components." (name k) ".url") nil)))
               (do (setValue "format" "vast-linear")
                   (setValue "processing" nil)
                   (setValue "placement" nil)
                   (setValue "components.video.url" nil))))})
       ($ hint "Choose which platform this ad is for."))))

(defui schedule-section []
  (let [schedule-enabled (rhf/useWatch #js {:name "schedule-enabled"})]
    ($ :<>
       ($ rhf/Controller
          {:name "schedule-enabled"
           :render (fn [^js props]
                     (let [{{:keys [onChange value]} :field} (->clj props)]
                       ($ FormControlLabel
                          {:control ($ Switch {:checked (boolean value)
                                               :onChange #(onChange (-> % .-target .-checked))
                                               :sx #js {:mr 1}})
                           :label "Schedule Ad"
                           :sx #js {:mx 0}})))})
       ($ Collapse {:in schedule-enabled
                    :unmountOnExit true}
          ($ Stack {:gap 2 :sx #js {:mt 2}}
             ($ schedule-modal/schedule-fields {:prefix "scheduling"}))))))

(defui targeting-values [{:keys [field-name]}]
  (let [{:keys [control]} (form/use-form-context)
        {:keys [fields append remove]} (form/use-field-array #js {:control control :name field-name})]
    ($ form-field
       {:label "Strategy labels"}
       ($ Stack {:gap 1}
          (for [[idx field] (mc/seq-indexed fields)]
            ($ targeting-value
               {:key (.-id field)
                :name (str field-name "[" idx "]")
                :on-delete #(remove idx)}))
          ($ Button
             {:onClick #(append #js {:name nil :value #js []})
              :startIcon ($ Plus)
              :sx #js {:alignSelf "flex-start"}}
             "Add strategy labels")))))

(defmodal manual-upload-modal :ad-variants/manual-upload-modal
  [{:keys [initial-ad]}]
  (let [adset (adset.h/use-adset)
        ad-type-options (hooks/use-ad-type-options adset)
        single-format   (when (= 1 (count ad-type-options))
                          (:value (first ad-type-options)))

        [add-more set-add-more] (uix/use-state false)
        [current-card-idx set-current-card-idx] (uix/use-state 0)
        {:keys [on-submit submitting]
         {:keys [control reset] :as form-control} :form-control}
        (hooks/use-ad-variant-upload-form {:initial-ad    initial-ad
                                           :single-format single-format
                                           :add-more      add-more
                                           :on-reset      #(set-current-card-idx 0)})

        {:keys [format processing fe-id ad-variant-uuid content-id] :as current-ad}
        (-> (rhf/useWatch #js {:control control}) ->clj)

        component-keys (hooks/use-component-keys format processing)

        ad-variant-scheduling-enabled? (use-flag :ad-variant-scheduling)
        video-format-field? (and (contains? #{"vast-linear" "vast-aws-prime"} format)
                                 (use-flag :ad-builder-stv-selection))]
    (uix/use-effect (fn []
                      reset)
                    [reset])
    ($ rhf/FormProvider (->js form-control)
       ($ modal-v2
          {:title (if initial-ad "Edit manual Ad" "Manual Ad creation")
           :sx #js {:minHeight "90vh"}
           :footer ($ Stack {:direction "row"
                             :justifyContent (if initial-ad "flex-end" "space-between")
                             :sx #js {:width "100%"}}
                      (when-not initial-ad
                        ($ checkbox {:label "Add more"
                                     :value add-more
                                     :on-change set-add-more}))
                      ($ Stack {:direction "row" :gap 1}
                         ($ Button {:variant "text"
                                    :sx #js {:color "text.primary"}
                                    :onClick #(rf/dispatch [:modal/close])}
                            "Cancel")
                         ($ Button {:variant "contained"
                                    :disabled (or (empty? format) submitting)
                                    :onClick on-submit}
                            (if initial-ad "Edit Ad" "Create"))))
           :dialog-content-props {:sx #js {:display "flex"
                                           :flexDirection "column"
                                           :mx -3
                                           :overflow "hidden"}}}
          ($ Stack
             {:key (or ad-variant-uuid fe-id)
              :direction "row"
              :sx (fn [^js theme]
                    #js {:minWidth "90vw"
                         :flex 1
                         :minHeight 0
                         :borderColor (.. theme -palette -divider)
                         :borderStyle "solid"
                         :borderWidth "1px 0"
                         :overflowY "auto"
                         :overflowX "hidden"})}
             ($ Stack
                {:gap 3
                 :sx #js {:flex "0 0 50%"
                          :height "100%"
                          :p 3}}
                (when-not single-format
                  ($ form-field {:label "Format"}
                     ($ form/autocomplete-field
                        {:control control
                         :name "format"
                         :field-props {:options ad-type-options}
                         :text-field-props {:autoFocus true}})))
                ($ form-field {:label "Content ID"}
                   ($ form/form-text-field
                      {:control control
                       :name "content-id"}))
                (when video-format-field?
                  ($ video-format-field))
                (for [ck component-keys
                      :let [input-component (get component-key->input-component ck)]
                      :when input-component]
                  ($ input-component
                     {:key (name ck)
                      :name (str "components." (name ck))
                      :format format
                      :content-id content-id
                      :card-index current-card-idx
                      :on-card-navigate set-current-card-idx}))
                (when ad-variant-scheduling-enabled?
                  ($ :<>
                     ($ Divider)
                     ($ schedule-section)))
                #_#_($ Divider)
                  ($ targeting-values
                     {:field-name "targeting-values"}))
             ($ Divider
                {:orientation "vertical"
                 :flexItem true
                 :sx #js {:position "sticky"
                          :top 0}})
             ($ Stack
                {:gap 3
                 :sx #js {:flex "0 0 50%"
                          :p 3
                          :backgroundColor "grey.90"
                          :overflow "hidden"
                          :justifyContent "center"
                          :position "sticky"
                          :top 0}}
                ($ variant-preview
                   {:variant (hooks/form-values>preview-ad-variant current-ad)
                    :hide-variant-info true
                    :disable-fullscreen true
                    :fill-available-height true
                    :carousel-controls {:card-index    current-card-idx
                                        :on-card-change set-current-card-idx}})))))))
